export default "/images/divide.svg?44e1e20b369eab7a9fbac9755eed43ee";